var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{ref:"optionRef",class:['option-container', { active: _setup.isSelected }],on:{"click":_setup.handleChooseOption}},[_c('span',{staticClass:"option-content"},[_vm._v(_vm._s(_vm.label || _vm.value))])])
}
var staticRenderFns = []

export { render, staticRenderFns }